import React from "react";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";
import { Spacer } from "@components/atoms";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { ProductCategory } from "@utils/constants";
import { isGemstone, isJewelry } from "@utils/product/productValidators";
import ProductHeaderDetail from "../utils/ProductHeaderDetail";
import PDPPriceContainer from "../utils/PriceContainer";
import { useTranslation } from "react-i18next";
import { css } from "styled-components/native";

interface PdpHeaderProps {
  // Data
  itemDetail: any;
  ref: any;
  productType: ProductCategory;
  priceMode: number;
  productColor: string;
  productAlphaColor: string;
  productName: string;
  showAvailabilityDot: boolean;
  isModal: boolean;
  isGuest: boolean;
  fromComponent?: boolean;

  // Layout
  sizes: {
    spacing: number;
  };

  // Layout handlers
  onLayout?: (e: any) => void;
}

const PdpHeader = ({
  ref,
  itemDetail,
  productType,
  priceMode,
  productColor,
  productAlphaColor,
  productName,
  showAvailabilityDot,
  isModal,
  isGuest,
  fromComponent,
  sizes,
  onLayout,
}: PdpHeaderProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <ParentViewContainer onLayout={onLayout}>
      <ProductHeaderDetail
        itemDetail={itemDetail}
        productType={productType}
        isJewelry={isJewelry(productType)}
        isGemstone={isGemstone(productType)}
        productColor={productColor}
        priceMode={priceMode}
        productAlphaColor={productAlphaColor}
        productName={productName}
        showAvailabilityDot={showAvailabilityDot}
        isModal={isModal}
      />
      {priceMode !== PriceModes.GREEN && (
        <ViewContainer isGem={isGemstone(productType)}>
          <Spacer size={sizes.spacing} />
          {!(isModal && fromComponent) && (
            <PDPPriceContainer
              ref={ref}
              isJewelry={isJewelry(productType)}
              isGuest={isGuest}
              theme={theme}
              t={t}
              productColor={productColor}
              itemDetail={itemDetail}
              priceMode={priceMode}
              productType={productType}
            />
          )}
        </ViewContainer>
      )}
    </ParentViewContainer>
  );
};

const ParentViewContainer = styled.View`
  width: 100%;
  flex-shrink: ${({ theme }) => (theme.isLargeScreen ? 1 : 0)};
  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-left: 10px;
      padding-right: 10px;
    `}
`;

const ViewContainer = styled.View<{ isGem: boolean }>`
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: ${({ isGem }) => (isGem ? 8 : 0)}px;
`;

export default PdpHeader;
